// DO NOT EDIT -- generated from Go package fs/model

import * as orgsproto from '@fullstory/proto/fs/services/orgs';


///////////
// Enums //
///////////

// Email digest setting
export enum Frequency {
	DigestOff = "off",
	DigestDaily = "daily",
	DigestWeekly = "weekly"
}

// DismissibleWarning settings
export enum DismissibleWarning {
	WarningUnknown = 0,
	WarningMetricSaveDeleteInsights = 1
}

export enum DateRangeID {
	AllTime = "allTime",
	Today = "today",
	Yesterday = "yesterday",
	Past60Minutes = "past60Minutes",
	Past3Hours = "past3Hours",
	Past6Hours = "past6Hours",
	Past24Hours = "past24Hours",
	PastWeek = "pastWeek",
	PastMonth = "pastMonth",
	Past90Days = "past90Days",
	PastYear = "pastYear",
	Since = "since",
	Custom = "custom"
}


///////////////
// Constants //
///////////////

export const BlockUnset: number = 0;
export const BlockExclude: number = 1;
export const BlockMask: number = 2;
export const BlockUnmask: number = 3;
export const BlockWatch: number = 4;
export const BlockKeep: number = 5;
export const FreemiumSessionQuota: number = 1e+03;
export const FreemiumSeats: number = 3;
export const FreemiumHistory: number = 1;
export const FreemiumAnalyticsHistory: number = 1;
export const FreeSessionQuota: number = 1e+04;
export const FreeSeats: number = 1e+01;
export const FreeHistory: number = 1;
export const FreeAnalyticsHistory: number = 1.2e+01;
export const TrialSessionQuota: number = 5e+03;
export const TrialSeats: number = 2e+01;
export const TrialHistory: number = 2;
export const History: number = 2;
export const AnalyticsHistory: number = 1.2e+01;
export const DataDirectHistory: number = 7;
export const DataDirectAnalyticsHistory: number = 7;

/////////////
// Structs //
/////////////

// OnboardingCompletion versions the completion of a specific org's onboarding process for a given person.
export interface OnboardingCompletion {
  OrgId: string;
  Version: number;
}

export interface ElementWatch {
  Selector: string;
  Consent: boolean;
  Type: number;
  Scope: orgsproto.RuleScope;
  Kind: string;
}

export interface UiElementWatch extends ElementWatch {
  Notes: string;
  LastUpdated: number;
  Label: string;
  TargetingConditions: string;
}

// Represents a "watched" Ajax request (XHR, fetch()). Ajax requests whose URLs match this filter will have their
// request/response bodies recorded in accordance with the Record[ReqRsp] enums.
// Keep in sync with '@fullstory/recording-api'.
export interface AjaxWatch {
  URLRegex: string;
  RecordReq: number;
  RecordRsp: number;
  ReqWhitelist: string;
  RspWhitelist: string;
  ReqAllowlist: string;
  RspAllowlist: string;
  ReqBody: boolean;
  RspBody: boolean;
}

export interface KnownDomain {
  Disabled: boolean;
  Domain: string;
}

export interface Level0 {
  PreFsod: boolean;
  SawFsodIntro: boolean;
  SawShare: boolean;
  SawWelcome: boolean;
  SawSearch: boolean;
  SawRageAndDeadClicks: boolean;
  SawInspectMode: boolean;
  SawSearchies: boolean;
  SawProDialogInTrial: number[] | null;
  GaveSearchV2Feedback: boolean;
  SawBetaPromoPopup: boolean;
  SawTrialWelcomeDialog: boolean;
  SawActivityMaps: boolean;
  SawActivityMapsL0: boolean;
  SawFS3Warning: boolean;
  SawFS3Warning2: boolean;
  SawSegmentFollowingDialog: boolean;
  SawEmailPrefs: boolean;
  CompletedOnboarding: Array<OnboardingCompletion | null> | null;
  SawGDPRMessage: boolean;
  SawFreemiumUpdate: boolean;
}

export interface OrgLevel0 {
  CompletedOnboardingVersion: number;
  CompletedPrivacyOnboarding: boolean;
  NewFreemium: boolean;
  AcceptedTermsVersion: number;
  SetupStage: orgsproto.SetupStage;
}

export interface Integration {
  Id: string;
  ServiceId: string;
  Enabled: boolean;
  AuthToken: string;
  JsonConfig: string;
  Config: {[key: string]: string} | null;
}

// CustomSeatRequestConfig will be used to manage custom seat requests for orgs.
export interface CustomSeatRequestConfig {
  Enabled: boolean;
  Text: string;
  Url: string;
}

// We need these exported for UiBoostrap
// TODO(sarahgrace): Remove these as we migrate them to orgsvc/protos.
export interface ToExport {
  Level0: Level0 | null;
  OrgLevel0: OrgLevel0 | null;
  Integration: Integration | null;
  CustomSeatRequestConfig: CustomSeatRequestConfig | null;
}
